export const API_PROFILE_URL = "/api/profile-data";
export const API_ALL_FACTORS_URL = "/api/factors";
export const API_ENROLL_PHONE_FACTOR_URL = "/api/factors/enroll-phone";
export const API_ENROLL_TOTP_FACTOR_URL = "/api/factors/enroll-totp";
export const API_ACTIVATE_FACTOR_URL = "/api/factors/activate-factor";
export const API_DELETE_FACTOR_URL = "/api/factors/delete-factor";
export const API_ENROLL_WEBAUTHN_FACTOR_URL = "/api/factors/enroll-webauthn";
export const API_ACTIVATE_WEBAUTHN_FACTOR_URL =
  "/api/factors/activate-webauthn";
export const API_CHANGE_PASSWORD_URL = "/api/credentials/change-password";

// Authentication/Authorization endpoints
export const API_CREATE_USER_URL = "/users";
export const API_AUTHENTICATE_USER_URL = "/authn";
export const API_GET_TRANSACTION_URL = "/transaction";
export const API_AUTH_ENROLL_PHONE_FACTOR_URL = "/authn/factors/enroll-phone";
export const API_AUTH_ENROLL_TOTP_FACTOR_URL = "/authn/factors/enroll-totp";
export const API_AUTH_ENROLL_WEBAUTHN_FACTOR_URL =
  "/authn/factors/enroll-webauthn";
export const API_AUTH_ACTIVATE_WEBAUTHN_FACTOR_URL =
  "/authn/factors/activate-webauthn";
export const API_AUTH_ACTIVATE_FACTOR_URL = "/authn/factors/activate";
export const API_AUTH_PREVIOUS_TRANSACTION_URL = "/authn/previous";
export const API_AUTH_SKIP_TRANSACTION_URL = "/authn/skip";
export const API_AUTHORIZE_USER_URL = "/authorize";

export const API_GET_FEATURE_FLAGS = "/feature-flags";
export const API_RECOVER_USERNAME = "/identities/recover-username";
